// Component
import ExampleInstruction from '../ExampleInstruction';
// Styles
import './Instructions.css';
// Translate
import { useTranslation } from 'react-i18next';
import InternalContainer from '../../Components/InternalContainer';

const Instructions = ({ searchType, data = 0 }) => {
  const { t } = useTranslation();
  const currentlyRoute = window.location.pathname.replace('/', '');

  const infoLibraryAdvanced = () => {
    return (
      <>
        <div className='instructionsContainer__video'>
          <p>{t('Crafting effective search queries')}</p>
        </div>
        <div className='instructionsContainer__instructions'>
          <h3>
            <b>{t('To refine your searches you can use')}:</b>
          </h3>
          <div>
            <p className='instructionsContainer__operator'>" "</p>
            <p className='instructionsContainer__description'>
              {t('to specify exact matching')}
            </p>
            <ExampleInstruction message={[`"${t('Pediatric phlebotomy')}"`]} />
          </div>

          <div>
            <p className='instructionsContainer__operator'>AND, OR, NOT</p>
            <p className='instructionsContainer__description'>
              {t('to add logic to to your search')}
            </p>
            <ExampleInstruction
              message={[
                `"${t('Climate change AND renewable energy')}"`,
                `"${t('Artificial intelligence OR machine learning')}"`,
                `"${t('Smartphones NOT Apple')}"`,
              ]}
            />
          </div>
          <div>
            <p className='instructionsContainer__operator'>( )</p>
            <p className='instructionsContainer__description'>
              {t('to group your search terms')}
            </p>
            <ExampleInstruction
              message={[
                `"${t(
                  '(climate change AND renewable energy) OR (global warming AND sustainable energy)'
                )}"`,
              ]}
            />
          </div>
        </div>
      </>
    );
  };

  const infoLibraryIA = () => {
    return (
      <>
        <div className='instructionsContainer__video'>
          <p>
            Crafting effective search queries is crucial for information
            retrieval. Enhance precision by using search equations with logical
            operators, refining and tailoring queries to align with specific
            criteria.
          </p>
        </div>
        <div className='instructionsContainer__instructionsIA'>
          <h3>
            <b>To refine your searches you can use:</b>
          </h3>
          <div className='instructionsContainer__instructionsText'>
            <p className='instructionsContainer__operator'>
              "Search for research articles on the effects of meditation on
              reducing blood pressure."
            </p>
            <p className='instructionsContainer__description'>
              This instruction is precise and specific. By saying "search for
              research articles," the user is requesting a concrete action: to
              find information. Finally, "on the effects of meditation on
              reducing blood pressure" specifies the topic.
            </p>
          </div>
        </div>
      </>
    );
  };

  if (
    currentlyRoute === 'articles' &&
    (searchType === 'advanced' || searchType === 'ia')
  ) {
    return (
      <section className='instructionsSection'>
        <InternalContainer className={data === 0 ? 'instructionfull' : ''}>
          <div className='instructionsContainer'>
            {searchType === 'advanced'
              ? infoLibraryAdvanced()
              : infoLibraryIA()}
          </div>
        </InternalContainer>
      </section>
    );
  }
};

export default Instructions;
